module.exports = __webpack_public_path__ + "static/media/cargo-ship-carrying-containers-sea-logistics.da77ea12.jpg";